import reduce from 'lodash/reduce';
import isObjectLike from 'lodash/isObjectLike';

function getUrlParams (name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

function typeOf (obj) {
  const toString = Object.prototype.toString;
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Event]': 'event',
    '[object Object]': 'object',
  };
  return map[toString.call(obj)];
}

function deepCopy (data) {
  const t = typeOf(data);
  let o;

  if (t === 'array') {
    o = [];
  }
  else if (t === 'object') {
    o = {};
  }
  else {
    return data;
  }

  if (t === 'array') {
    for (let i = 0; i < data.length; i++) {
      o.push(deepCopy(data[i]));
    }
  }
  else if (t === 'object') {
    for (let i in data) {
      o[i] = deepCopy(data[i]);
    }
  }
  return o;
}

const emailHash = {
  'qq.com': 'http://mail.qq.com',
  'gmail.com': 'http://mail.google.com',
  'sina.com': 'http://mail.sina.com.cn',
  '163.com': 'http://mail.163.com',
  '126.com': 'http://mail.126.com',
  'yeah.net': 'http://www.yeah.net/',
  'sohu.com': 'http://mail.sohu.com/',
  'tom.com': 'http://mail.tom.com/',
  'sogou.com': 'http://mail.sogou.com/',
  '139.com': 'http://mail.10086.cn/',
  'hotmail.com': 'http://www.hotmail.com',
  'live.com': 'http://login.live.com/',
  'live.cn': 'http://login.live.cn/',
  'live.com.cn': 'http://login.live.com.cn',
  '189.com': 'http://webmail16.189.cn/webmail/',
  'yahoo.com.cn': 'http://mail.cn.yahoo.com/',
  'yahoo.cn': 'http://mail.cn.yahoo.com/',
  'eyou.com': 'http://www.eyou.com/',
  '21cn.com': 'http://mail.21cn.com/',
  '188.com': 'http://www.188.com/',
  'foxmail.com': 'http://www.foxmail.com',
};

function emailDomain (email) {
  const domain = email.split('@')[1];
  return emailHash[domain];
}

function addQueryStringArg (url, name, value) {
  if (url.indexOf('?') === -1) {
    url += '?';
  }
  else {
    url += '&';
  }
  url += encodeURIComponent(name) + '=' + encodeURIComponent(value);
  return url;
}

function searchTag (tag, url) {
  const tags = document.getElementsByTagName(tag);

  const list = [];
  const _len = tags.length;
  for (let i = 0; i < _len; i++) {
    list.push(tags[i]);
  }

  return list.some(item => item.src === url);
}

function asyncLoadJs (url) {
  return new Promise((resolve, reject) => {
    let hasLoaded = searchTag('script', url);
    if (hasLoaded) {
      resolve();
      return;
    }

    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    document.body.appendChild(script);
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject(new Error(`异步加载js错误：${url}`));
    };
  });
}

// 省市区切割
function splitAddress (addr) {
  if (!addr || addr === '' || +addr === -1) {
    return {
      province: '',
      city: '',
      district: '',
      address: '',
    };
  }
  const newAddr = addr.replace(/\s+/g, '');
  const arr = /(.+?(?:省|市|区))(.+?(?:市|区|县|盟|自治州))?(.+?(?:县|区|市|旗|乡|镇|街道))?(.*)?/.exec(
    newAddr);

  if (!arr) {
    return {
      province: '',
      city: '',
      district: '',
      address: addr,
    };
  }

  return {
    input: arr[0] || '',
    province: arr[1] || '',
    city: arr[2] || '',
    district: arr[3] || '',
    address: arr[4] || '',
  };
}

/**
 * 深度处理
 * @param src Object / Array
 * @param reviver (key, value, parent) => {}
 * @returns {*}
 */
function deepDeal (src, reviver) {
  let clone;

  // 对于 数字 字符串 布尔 null undefined
  if (src == null || typeof src !== 'object') {
    return src;
  }

  // 对于 Date
  if (src instanceof Date) {
    clone = new Date(src.getDate());
    return clone;
  }

  // 对于 数组
  if (src instanceof Array) {
    clone = [];
    for (let i = 0, len = src.length; i < len; i++) {
      clone[i] = deepDeal(src[i], reviver);
      reviver && reviver(i, src[i], src);
    }
    return clone;
  }

  // 对于 Object
  if (src instanceof Object) {
    clone = {};
    for (let key in src) {
      if (src.hasOwnProperty(key)) { // 忽略掉继承属性
        clone[key] = deepDeal(src[key], reviver);
        reviver && reviver(key, src[key], src);
      }
    }
    return clone;
  }
}

/**
 * 根据path安全获取值
 * @param object 取值的对象
 * @param path 属性path
 * @param defaultValue 默认值
 * @returns {*}
 */
function getValueByPath (object, path, defaultValue) {
  // 对像为null
  if (object === null) {
    if (defaultValue !== undefined) {
      return defaultValue;
    }
    return;
  }

  var paths = path.split('.');

  // 遍历路径
  var val = paths.reduce(function (prev, item) {
    if (prev === undefined || prev === null) {
      return prev;
    }
    return prev[item];
  }, object);

  // 如拿到的值为undefined,返回默认值
  if (val === undefined) {
    return defaultValue;
  }
  return val;
}

function randomString (digit = 32) {
  let baseStrs = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0, len = baseStrs.length; i < digit; i++) {
    result += baseStrs.charAt(Math.floor(Math.random() * len));
  }
  return result;
}

/**
 * 递归取值
 * @ {}
 * @author joneshe
 */
function getPropertyRecursive (obj, prop) {
  return reduce(obj, function (result, value, key) {
    if (key === prop) {
      result.push(value);
    }
    else if (isObjectLike(value)) {
      return result.concat(getPropertyRecursive(value, prop));
    }

    return result;
  }, []);
}

// 函数参数必须是字符串，因为二代身份证号码是十八位，而在javascript中，十八位的数值会超出计算范围，造成不精确的结果，导致最后两位和计算的值不一致，从而该函数出现错误。
// 详情查看javascript的数值范围
function checkIDCard (idcode) {
  // 加权因子
  let weightFactor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  // 校验码
  let checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
  let code = idcode + '';
  let last = idcode[17];// 最后一个
  let seventeen = code.substring(0, 17);

  // ISO 7064:1983.MOD 11-2
  // 判断最后一位校验码是否正确
  let arr = seventeen.split('');
  let len = arr.length;
  let num = 0;
  for (let i = 0; i < len; i++) {
    num = num + arr[i] * weightFactor[i];
  }

  // 获取余数
  let resisue = num % 11;
  let lastNo = checkCode[resisue];
  // 格式的正则
  // 正则思路
  /*
  第一位不可能是0
  第二位到第六位可以是0-9
  第七位到第十位是年份，所以七八位为19或者20
  十一位和十二位是月份，这两位是01-12之间的数值
  十三位和十四位是日期，是从01-31之间的数值
  十五，十六，十七都是数字0-9
  十八位可能是数字0-9，也可能是X
  */
  let idcardPatter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;

  // 判断格式是否正确
  let format = idcardPatter.test(idcode);

  // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
  return last === lastNo && format;
}

// 手机号检查
function checkMobilePhone (mobilePhone) {
  return /^1[3456789]\d{9}$/.test(mobilePhone);
}

// IP检查
function checkIp (ip) {
  return /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(
    ip);
}

// 域名检查
function checkDomain (domain) {
  return /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/.test(
    domain);
}

// 特殊字符检查
function checkSpecialCode (code) {
  return new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_]").test(code);
}

// 字节转换
function readablizeBytes (bytes) {
  const s = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const e = Math.floor(Math.log(bytes) / Math.log(1024));
  return (bytes / Math.pow(1024, Math.floor(e))).toFixed(2) + ' ' + s[e];
}

function isPromise (e) {
  return !!e && typeof e.then === 'function';
}

/**
 * base64解码
 * @param {*} str 需要转换的字符串
 */
function base64ToUtf8 (str) {
  return decodeURIComponent(escape(atob(str)));
}

/**
 * base64编码
 * @param {*} str 需要转换的字符串
 */
function utf8ToBase64 (str) {
  return btoa(unescape(encodeURIComponent(str)));
}

export {
  getUrlParams,
  deepCopy,
  deepDeal,
  addQueryStringArg,
  emailDomain,
  asyncLoadJs,
  splitAddress,
  typeOf,
  getValueByPath,
  randomString,
  getPropertyRecursive,
  checkIDCard,
  checkMobilePhone,
  isPromise,
  checkIp,
  checkDomain,
  checkSpecialCode,
  base64ToUtf8,
  utf8ToBase64,
  readablizeBytes,
};
